<ion-list class="ion-no-margin ion-no-padding">
  <ion-item button [disabled]="!hasGrantToWriteEmployee" id="open-modal">{{ "BEACON.ASSIGN" | translate }}</ion-item>
  <ion-item [disabled]="!hasGrantToWriteEmployee" button (click)="onClickEdit()">{{'EDIT'|translate}}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteEmployee" *ngIf="!employeeDto.active"  (click)="onClickActivate()">{{'ACTIVATE' | translate}}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteEmployee" *ngIf="employeeDto.active"  (click)="onClickDeactivate()">{{'DEACTIVATE' | translate}}</ion-item>
  <ion-item [disabled]="!hasGrantToWriteEmployee" button (click)="onClickDelete()">{{'DELETE'|translate}}</ion-item>
  <!-- Comment the next line because throws error in build process -->
  <!-- <ion-item [disabled]="!hasGrantToWriteEmployee" *ngIf="employeeDto.employeeState=='ACTIVE'" button (click)="onClickDelete()">{{'DELETE'|translate}}</ion-item>
  <ion-item [disabled]="!hasGrantToWriteEmployee" *ngIf="employeeDto.employeeState=='INACTIVE'" button (click)="onClickActivate()">{{'ACTIVATE'|translate}}</ion-item>   -->
</ion-list>

<ion-modal 
[initialBreakpoint]="1"
[breakpoints]="[0, 1]"
trigger="open-modal"
#modal>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{'BEACON.ASSIGN'|translate}}</ion-title>
        <ion-buttons slot="start">
          <ion-button (click)="modal.dismiss()"><span>{{'CANCEL'|translate}}</span></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-searchbar debounce="500" placeholder="{{'SEARCH' | translate}}" (ionInput)="onSearch($event)"></ion-searchbar>
      <ion-list>
        <ion-item *ngFor="let beacon of beaconsList" (click)="selectBeacon(beacon.mac)">
          <div>
            <p>{{beacon.serial}}</p>
            <p class="machine_name">
            <span *ngIf="beacon.employee">{{'BEACON.ASSIGNED_EMPLOYEE' | translate}}: {{getEmployeeName(beacon.employee)}} </span>
            </p>
            </div>
        </ion-item>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-modal>
